<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
    	<el-breadcrumb-item>能耗分析</el-breadcrumb-item>
    	<el-breadcrumb-item>抄表统计</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索筛选 -->
    <el-form :inline="true"  class="user-search"  @submit.native.prevent>
      <el-form-item v-if="user.username == 'admin'" label="选择部门">
          <el-select v-model="depId" placeholder="请选择部门"  size="small" @change="chageDept">
             <el-option
               v-for="item in deptList"
               :key="item.id"
               :label="item.departmentName"
               :value="item.id">
             </el-option>
           </el-select>
       </el-form-item>



      <el-form-item>
      	<div style="position: relative;top: 1px;">
      	<el-date-picker
      	  size="small"
      	  v-model="date"
          value-format="yyyy-MM-dd"
      	  type="date"

      	  @change="getDate"
      	 >
      	</el-date-picker>
      	</div>
      </el-form-item>


    	<el-form-item>
    		<el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
    	</el-form-item>
    </el-form>

    <el-table  :header-cell-style="this.$store.state.headerCss" size="small" :data="dataList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
     style="width: 100%;"  stripe :max-height="tableHeight" >
    	<el-table-column align="center" type="index" width="60">
    	</el-table-column>


    	<el-table-column prop="meterTotal" label="计量点总数"  show-overflow-tooltip>
    	</el-table-column>
      <el-table-column prop="readingTotal" label="抄表总数"  show-overflow-tooltip>
    	</el-table-column>
      <el-table-column prop="terminalTotal" label="集中器总数"  show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="success" label="成功率"  show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="failure" label="失败率"   show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="createDate" label="抄表时间"   show-overflow-tooltip>
      </el-table-column>
      <el-table-column  label="能源种类"  show-overflow-tooltip>
        <template slot-scope="scope">
          <el-tag size="mini" type="warning" v-if="scope.row.energyType == '15'">电</el-tag>
          <el-tag size="mini"  v-if="scope.row.energyType == '16'">水</el-tag>
          <el-tag size="mini" type="danger" v-if="scope.row.energyType == '18'">热能</el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作" center width="180">
        <template slot-scope="scope">
           <el-button size="mini" @click="showChild(scope.row)">查看子表</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-if="showPage" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>


    <el-dialog  title="查看子表"  :visible.sync="subFrom" width="70%" @click='subFrom = false' @close="childClose">


    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click='subFrom = false'>取消</el-button>
    		<!-- <el-button size="small" type="primary" :loading="setLoading" class="title" @click="saveChild()">确认</el-button> -->
    	</div>
    </el-dialog>
  </div>
</template>

<script>
  import { findMeterReadingTotalByDepId  } from '../../api/payMG.js'
 import { getDepartmentTerminalInfoLis  } from '../../api/energyMG.js'
  import {timestampToTime} from '@/utils/util'
  import Pagination from '../../components/Pagination'
  export default{
    data(){
      return {
        subFrom:false,
        dataList:[],
        tableHeight:0,
        date:"",
        user:{},
        diff:0,
        showPage:true,
        loading:false,
        deptList:[],
        depId:'',
        pageparm: {
        	currentPage: 1,
        	pageSize: 10,
        	total: 10
        },

      }
    },
    created(){
      this.user = JSON.parse(sessionStorage.getItem('userdata'))
      let d = new Date()
      let s = new Date(d.getTime() - (2 * 24 * 60 * 60 * 1000))
      let e = new Date(d.getTime())
      this.date = timestampToTime(e).substring(0,10)
      this.getJzData()

    },
    mounted(){
      this.$nextTick(() => {
        this.tableHeight = window.innerHeight - 300
      })
    },
    components: {
    	Pagination
    },
    methods:{
      getJzData:function(){
      	return new Promise((resolve,reject) => {
      		getDepartmentTerminalInfoLis().then(res => {
      			this.treeLoad = false
      			if(res.status == 1){
      				let arr = []
      				this.deptList = res.data.menuDepList
              this.depId = res.data.menuDepList[0].id
              this.getData()
      			}
      			else{
      				this.$message.error(res.msg)
      			}
      		})
      	})

      },



      chageDept(e){
        this.getData()


      },
      getDate(val){
        console.log(val)
        this.date = val
        this.getData()
      },



      childClose(){
        this.breadList = []
      },
      search(){

          this.pageparm.currentPage = 1

          this.showPage  =  false;
          this.getData()
          this.$nextTick(() => {
          	this.showPage = true
          })
      },
      callFather(parm){
        this.pageparm.currentPage = parm.currentPage
        this.pageparm.pageSize = parm.pageSize
        this.getData()
      },
      callFatherSub(param){
        this.subPageParm.currentPage = param.currentPage
        this.subPageParm.pageSize = param.pageSize
        this.getChildData()
      },
      getData(){
        this.loading = true

        let param  = {
          date:this.date,
          depId:this.depId
        }
        findMeterReadingTotalByDepId(param).then(res => {
          this.loading = false
          if(res.status == 1) {
            this.dataList = res.data

          }else{
            this.$message.error(res.msg)
          }
        })
      },


    }
  }
</script>

<style>
  .stepBox{
    margin-bottom: 20px;
    display: flex;
  }
  .rowRed{
    color: red;
  }
  .stepItem{
    display: flex;
    cursor: pointer;
    margin-right: 10px;
    line-height: 14px;
  }
  .stepItem:hover{
    color: #409EFF;
  }
</style>



// WEBPACK FOOTER //
// src/views/analysis/chaoBiao.vue